import { render, staticRenderFns } from "./SolarVsGrid.vue?vue&type=template&id=28db5038&scoped=true&"
import script from "./SolarVsGrid.vue?vue&type=script&lang=ts&"
export * from "./SolarVsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./SolarVsGrid.vue?vue&type=style&index=0&id=28db5038&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28db5038",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
